( function( $ ) {
  $.bigfoot();
})( jQuery );
